import LoadingOverlay from '@components/LoadingOverlay/LoadingOverlay';
import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';

interface MainLoadingOverlayProps {
  children: React.ReactNode | React.ReactNode[];
}

/**
 * MainLoadingOverlay component.
 *
 * This component will be used to show a loading overlay across the entire application. Currently used to show a loading overlay when there is a call being accepted.
 * But can be used for other global loading states in the future.
 */
const MainLoadingOverlay = ({ children }: MainLoadingOverlayProps) => {
  const { callsAccepting } = usePhoneState();

  const loading = callsAccepting.length > 0;

  return <LoadingOverlay loading={loading}>{children}</LoadingOverlay>;
};

export default MainLoadingOverlay;
